/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: false, // Change this to false if you want the good'ol cursor
};

//Home Page
const greeting = {
  title: "Hello 👋.",
  title2: "Wajdi Mnasri",
  logo_name: "XVII",
  nickname: "Wajdi",
  full_name: "Wajdi Mnasri",
  subTitle: " Full Stack AI Engineer🔥. Always learning.",
  resumeLink: "cv.pdf",
  mail: "mailto:wajdi.mnasri@outlook.com",
};

const socialMediaLinks = {
  github: "https://github.com/Wajdi15",
  gmail: "wajdi.mnasri@outlook.com",
  linkedin: "http://linkedin.com/in/wajdi-mnasri-0534511b3",
};

const skills = {
  data: [
    {
      title: "Full Stack & Backend",
      fileName: "FullStackImg",
      skills: [
        "⚡ Build production-ready REST APIs and microservices with FastAPI, Django and Node/Express",
        "⚡ Design interactive front ends and web apps with React.js and Next.js",
        "⚡ Develop cross-platform mobile applications with React Native",
        "⚡ Model relational and document data with PostgreSQL, MongoDB and Supabase",
        "⚡ Integrate third-party services, authentication and payment workflows (Stripe, SendGrid)",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
        {
          skillName: "FastAPI",
          fontAwesomeClassname: "simple-icons:fastapi",
          style: {
            color: "#009688",
          },
        },
        {
          skillName: "Django",
          fontAwesomeClassname: "simple-icons:django",
          style: {
            color: "#092E20",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "simple-icons:typescript",
          style: {
            color: "#3178C6",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Next.js",
          fontAwesomeClassname: "simple-icons:nextdotjs",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "React Native",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },
      ],
    },
    {
      title: "AI & Computer Vision",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Fine-tune deep learning and computer vision models with PyTorch (SAM2 for image segmentation)",
        "⚡ Build end-to-end AI inference pipelines from prototype to production",
        "⚡ Develop LLM & GenAI applications with LangChain, RAG and vector databases",
        "⚡ Process, clean and validate data using Pandas and NumPy",
        "⚡ Automate structured reporting and clinical data quality control",
      ],
      softwareSkills: [
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "simple-icons:pytorch",
          style: {
            color: "#EE4C2C",
          },
        },
        {
          skillName: "LangChain",
          fontAwesomeClassname: "simple-icons:langchain",
          style: {
            color: "#1C3C3C",
          },
        },
        {
          skillName: "OpenCV",
          fontAwesomeClassname: "simple-icons:opencv",
          style: {
            color: "#5C3EE8",
          },
        },
        {
          skillName: "Pandas",
          fontAwesomeClassname: "simple-icons:pandas",
          style: {
            color: "#150458",
          },
        },
        {
          skillName: "NumPy",
          fontAwesomeClassname: "simple-icons:numpy",
          style: {
            color: "#013243",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
      ],
    },
    {
      title: "DevOps & Cloud",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Containerize and orchestrate services with Docker and Kubernetes",
        "⚡ Deploy production workloads on AWS and OVH VPS",
        "⚡ Manage Linux servers and Git/Bitbucket-based workflows",
      ],
      softwareSkills: [
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#2496ED",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Linux",
          fontAwesomeClassname: "simple-icons:linux",
          style: {
            color: "#FCC624",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
        
    {
      title: " ISITCOM ,Sousse Tunisia",
      subtitle: "ISITCOM",
      logo_path: "isitcom.png",
      alt_name: "ISITCOM",
      duration: "2022 - 2025",
      descriptions: [
        "⚡ Engineering Degree in Teleinformatics.",
        // "⚡ I have studied subjects like Angular, DBMS, Node.js, etc.",
        // "⚡ I have also completed various online courses for Backend , Web , Mobile App Development, etc.",
        // "⚡ I have implemented several projects based on what I've leart under my Computer Engineering course. ",
      ],
    },
    
    {
      title: "ISET ,Sidi Bouzid Tunisia",
      subtitle: "ISET SBZ",
      logo_path: "ISET.jpg",
      alt_name: "ISET",
      duration: "2019 - 2022",
      descriptions: [
        "⚡ License in Web Development and Multimedia.",
        "⚡ I have studied subjects like Angular, DBMS, Node.js, etc.",
        // "⚡ I have also completed various online courses for Backend , Web , Mobile App Development, etc.",
        // "⚡ I have implemented several projects based on what I've leart under my Computer Engineering course. ",
      ],
    },
    {
      title: "Baccalaureate",
      subtitle: "BAC",
      logo_path: "ssgandhy.png",
      alt_name: "SSGC",
      duration: "2019",
      descriptions: [
        "⚡ I have studied technical Baccalaureate in the high school of Bir Elhfey",
      ],
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work And Internship",
  description:
    "Full Stack AI Engineer with 2+ years of experience building AI-powered applications, backend APIs and data-driven systems, with hands-on work in healthcare and medical imaging — taking projects from prototype to production.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work Experience",
      experiences: [
        {
          title: "R&D Engineer",
          company: "Womia",
          logo_path: "valora.jpg",
          duration: "Jul 2024 - Present",
          location: "Tunisia",
          description: `
            Built and deployed end-to-end medical imaging pipelines for cardiac MRI
            analysis, covering data ingestion, segmentation, post-processing, validation
            and structured report generation.
            Fine-tuned SAM2-based computer vision models with PyTorch for cardiac MRI
            segmentation and automated medical image analysis.
            Developed production-ready REST APIs with FastAPI to connect AI inference,
            reporting workflows, internal tools and downstream medical software.
            Built and integrated a Stripe-based payment module with checkout workflows,
            payment handling and SendGrid email notifications.
            Deployed backend services using Docker, Kubernetes, OVH VPS and AWS for
            production and release environments.
            Integrated CardioInspect reporting into the ArtFun+ pipeline and automated
            structured clinical report generation from processed cardiac MRI data.
          `,

          color: "#c3f584",
        },
        {
          title: "Full Stack Developer",
          company: "SMART WMN",
          logo_path: "valora.jpg",
          duration: "Aug 2022 - Jun 2024",
          location: "Tunisia",
          description: `
            Developed and maintained front-end features for XQual, a test management
            platform used to manage quality assurance workflows.
            Built dynamic, reusable UI components with React.js, JavaScript, jQuery and
            Bootstrap to improve platform usability.
            Implemented a Node.js and Express.js proxy service to support local
            development, testing and integration workflows.
            Collaborated in an Agile environment on bug fixing, feature delivery and
            code maintenance.
          `,

          color: "#c3f584",
        },
        {
          title: "Full Stack Developer Intern",
          company: "Smart Team Group",
          logo_path: "valora.jpg",
          duration: "Feb 2022 - Jul 2022",
          location: "Tunisia",
          description: `
            Developed an interactive data import module for business applications,
            supporting validation and workflow management.
            Integrated heterogeneous data sources and implemented data quality handling
            for import processes (encoding, deduplication, reference matching).
            Built UI components using JavaScript spreadsheet tools, including TreeGrid,
            to improve data review and editing.
            Supported backend development with Node.js, Express.js, Docker and Git.
          `,

          color: "#0071C5",
        },
        {
          title: "Mobile Developer Intern",
          company: "RIATICA",
          logo_path: "valora.jpg",
          duration: "Jul 2021 - Aug 2021",
          location: "Tunisia",
          description: `
            Developed a mobile application using React Native with backend services
            built on Node.js and Firebase.
            Implemented authentication and data handling using JWT, MongoDB and
            Firebase services.
          `,

          color: "#0071C5",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "My Projects",
  description:
    "From production AI and medical-imaging systems built at work to full-stack web and mobile apps, my projects span backend APIs, computer vision, and data-driven applications. Below are some of my professional and personal projects:",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "wajdi.jpeg",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
};

const projects = {
  data: [
    {
      id: "9",
      name: "Skin Cancer Detection App",
      description:
        "A React Native mobile app that detects skin cancer from images using a deep learning AI model.",
      languages: [
        {
          name: "React Native",
          iconifyClass: "logos-react",
        },
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "TensorFlow",
          iconifyClass: "logos-tensorflow",
        },
      ],
    },
    {
      id: "w1",
      name: "AI Medical Image Segmentation",
      description:
        "Built end-to-end medical imaging pipelines and fine-tuned SAM2 computer vision models for cardiac MRI segmentation, covering data ingestion, post-processing and validation.",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "PyTorch",
          iconifyClass: "logos-pytorch",
        },
        {
          name: "OpenCV",
          iconifyClass: "logos-opencv",
        },
        {
          name: "Docker",
          iconifyClass: "logos-docker",
        },
      ],
    },
    {
      id: "w2",
      name: "Automated Clinical Reporting API",
      description:
        "Developed production FastAPI backends that connect AI inference to reporting workflows and automate structured clinical report generation from processed cardiac MRI data.",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "FastAPI",
          iconifyClass: "logos-fastapi-icon",
        },
        {
          name: "PostgreSQL",
          iconifyClass: "logos-postgresql",
        },
        {
          name: "Kubernetes",
          iconifyClass: "logos-kubernetes",
        },
      ],
    },
    {
      id: "w3",
      name: "Payment & Checkout Integration",
      description:
        "Built a payment module with Stripe checkout workflows, payment handling and email notifications, integrated into production backend services.",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "FastAPI",
          iconifyClass: "logos-fastapi-icon",
        },
        {
          name: "Stripe",
          iconifyClass: "logos-stripe",
        },
      ],
    },
    {
      id: "w4",
      name: "QA Test Management Front-End",
      description:
        "Developed front-end features and reusable UI components for a quality-assurance test management platform, plus a Node.js proxy for local test environments.",
      languages: [
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "jQuery",
          iconifyClass: "logos-jquery",
        },
        {
          name: "NodeJS",
          iconifyClass: "logos-nodejs",
        },
      ],
    },
    {
      id: "6",
      name: "Real Estate Marketplace Web App",
      description: "Modern Real Estate Marketplace with react MERN",
      languages: [
        {
          name: "Node",
          iconifyClass: "logos-nodejs",
        },
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "express",
          iconifyClass: "logos-express",
        },
        {
          name: "mongodb",
          iconifyClass: "logos-mongodb",
        },
      ],
    },
    {
      id: "8",
      name: "Zaiemer View",
      description:
        "The aim of the project is to develop a model for predicting the risk of zaiemer disease.",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "Tensorflow",
          iconifyClass: "logos-tensorflow",
        },
        {
          name: "Django",
          iconifyClass: "logos-django",
        },
      ],
    },
    {
      id: "5",
      name: "Football analysis App",
      description: "A simple Chat application.",
      languages: [
        {
          name: "python",
          iconifyClass: "logos-python",
        },
        {
          name: "opencv",
          iconifyClass: "logos-opencv",
        },
      ],
    },
    {
      id: "1",
      name: "Motv",
      description:
        "This Mobile App is for finding and tracking movies & series on Android and IOS.",
      languages: [
        {
          name: "Firebase",
          iconifyClass: "logos-firebase",
        },
        {
          name: "Expo",
          iconifyClass: "logos-expo",
        },
        {
          name: "ReactNative",
          iconifyClass: "logos-react",
        },
      ],
    },
    {
      id: "4",
      name: "personal-portfolio",
      description: "My Web Site :)",
      languages: [
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "NodeJS",
          iconifyClass: "logos-nodejs",
        },
      ],
    },
    {
      id: "0",
      name: "Burger Builder",
      description:
        "A Web App that helps clients to build their own burger in resto.",
      languages: [
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "Firebase",
          iconifyClass: "logos-firebase",
        },
      ],
    },
    {
      id: "2",
      name: "Telegram Bot",
      description:
        "This is Telegram Bot. This will get the RSI of crypto from Trading View.",
      languages: [
        {
          name: "Nodejs",
          iconifyClass: "logos-nodejs",
        },
        {
          name: "Puppeteer",
          iconifyClass: "logos-puppeteer",
        },
      ],
    },
    {
      id: "4",
      name: "Chat Application",
      description: "A simple Chat application.",
      languages: [
        {
          name: "react",
          iconifyClass: "logos-react",
        },
        {
          name: "express",
          iconifyClass: "logos-express",
        },
        {
          name: "mongodb",
          iconifyClass: "logos-mongodb",
        },
      ],
    },
    {
      id: "3",
      name: "To Do List",
      description:
        "Organize, plan, and collaborate on tasks and projects with To Do List app.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "express",
          iconifyClass: "logos-express",
        },
        {
          name: "mongodb",
          iconifyClass: "logos-mongodb",
        },
      ],
    },
    {
      id: "3",
      name: "node_express_crud_api_starter",
      description: "Simple NodeJS Express CRUD Operations API starter.",
      languages: [
        {
          name: "NodeJS",
          iconifyClass: "logos-nodejs",
        },
      ],
    },
    {
      id: "7",
      name: "A management application food store resources",
      description: "",
      languages: [
        {
          name: "Java",
          iconifyClass: "logos-java",
        },
        {
          name: "Android",
          iconifyClass: "logos-android",
        },
      ],
    },
  ],
}

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
